import { changeLoading, changeReturnUrl } from "@/app/appSlice"
import axios, { AxiosResponse } from "axios"
import { RootState } from "./store"
import { DateTime, Settings } from "luxon"
import md5 from "crypto-js/md5"

const $axios = axios.create()
export const useSetUpAxios = () => {
  const lang = useAppSelector((state: RootState) => state.app.lang)
  // const clientType = useAppSelector((state: RootState) => state.app.clientType)
  // const token = useAppSelector((state: RootState) => state.app.token)

  $axios.interceptors.request.use(
    (config) => {
      config.baseURL = import.meta.env.VITE_APP_API_DOMAIN
      console.log(config.baseURL)
      // Do something before request is sent
      // const data = {
      //   appID: import.meta.env.VITE_APP_APPID,
      //   // lang,
      //   ver: APP_VERSION,
      //   // clientType,
      // }
      // config.params = {
      //   ...config.params,
      //   // lang,
      //   ...data,
      // }
      // config.data= {
      //   ...config.data,
      //   lang,
      // }
      if (import.meta.env.VITE_APP_API_SECRET)
        config.headers.Authorization = `Bearer ${
          import.meta.env.VITE_APP_API_SECRET
        }`
      const timestampmils = DateTime.now().toMillis()
      config.headers["x-storellet-appid"] = import.meta.env.VITE_APP_APPID
      config.headers["x-storellet-timestamp"] = timestampmils
      config.headers["x-storellet-appversion"] = APP_VERSION
      config.headers["x-storellet-checksum"] = md5(
        timestampmils.toString() + import.meta.env.VITE_APP_API_SECRET,
      )
      //   .toString()
      //   .toLowerCase()
      // config.headers["Content-Type"] =
      return config
    },
    function (error) {
      // Do something with request error
      console.error(error)
      return Promise.reject(error)
    },
  )

  if (lang === "zh") Settings.defaultLocale = "zh-hk"
  if (lang === "cn") Settings.defaultLocale = "zh-cn"
  if (lang === "en") Settings.defaultLocale = "en-gb"
}

export const useLocalize = () => {
  const lang = useAppSelector((state: RootState) => state.app.lang)
  return (obj: { [key: string]: any }, keyStr: string) => {
    if (lang === "en") return obj[keyStr]

    let _keyStr = ""
    let keySuffix = ["Zh", "_zh", "_Zh", "_ZH", "ZH", "zh"]
    keySuffix.forEach((element: string) => {
      if (keyStr + element in obj) {
        _keyStr = keyStr + element
        return
      }
    })
    return obj[_keyStr]
  }
}

type LoginRequest = {
  phone: string
  email: string
  code: string
  lang: string
}

type LoginResponse = {
  success: boolean
  error: string
  retryInSeconds: number
  otpTarget: string
  lang: string
}

export const useLoginRequest = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const lang = useAppSelector((state: RootState) => state.app.lang)
  const api = (phone: string, email: string, code: string) =>
    new Promise<LoginResponse>(async (resolve, reject) => {
      dispatch(changeLoading(true))
      try {
        const req: LoginRequest = {
          phone,
          email,
          code,
          lang,
        }

        const res = await $axios.post<
          LoginResponse,
          AxiosResponse<LoginResponse>,
          LoginRequest
        >("/oauth/login", req)
        console.log(res)
        resolve(res.data)
      } catch (e: any) {
        if (e?.response?.data?.error === "invalid_request") {
          navigate("/error")
        }
        resolve(e.response.data)
      } finally {
        dispatch(changeLoading(false))
      }
    })

  return api
}

type RegisterRequest = {
  lang: string
  phone: string
  email: string
  code: string
  password: string
}

export const useRegisterRequest = () => {
  const dispatch = useAppDispatch()
  const savedPassword = useAppSelector((state: RootState) => state.app.password)
  const lang = useAppSelector((state: RootState) => state.app.lang)
  const api = (phone: string, email: string, code: string, password?: string) =>
    new Promise<LoginResponse>(async (resolve, reject) => {
      dispatch(changeLoading(true))
      try {
        const res = await $axios.post<
          LoginResponse,
          AxiosResponse<LoginResponse>,
          RegisterRequest
        >("/oauth/register", {
          lang,
          phone,
          email,
          code,
          password: password || savedPassword,
        })
        console.log(res)
        resolve(res.data)
      } catch (e: any) {
        resolve(e.response.data)
      } finally {
        dispatch(changeLoading(false))
      }
    })

  return api
}

type OtpRequest = {
  code: string
  otp: string
  email: string
  lang: string
  phone: string
  password: string
}

type otpResponse = {
  success: boolean
  returnUrl: string
  error: string
  state: string
}

export const useOtpRequest = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const email = useAppSelector((state: RootState) => state.app.email)
  const code = useAppSelector((state: RootState) => state.app.code)
  const lang = useAppSelector((state: RootState) => state.app.lang)
  const phone = useAppSelector((state: RootState) => state.app.phone)
  const countryCode = useAppSelector(
    (state: RootState) => state.app.countryCode,
  )
  const password = useAppSelector((state: RootState) => state.app.password)

  const api = (otp: string) =>
    new Promise<otpResponse>(async (resolve, reject) => {
      dispatch(changeLoading(true))

      const request: OtpRequest = {
        code,
        otp,
        email: email,
        lang,
        phone: phone ? countryCode + phone : "",
        password: password,
      }

      try {
        const res = await $axios.post<
          otpResponse,
          AxiosResponse<otpResponse>,
          OtpRequest
        >("/oauth/otp", request)
        console.log(res)
        resolve(res.data)
        if (res.data.success) {
          dispatch(changeReturnUrl(res.data.returnUrl))
          navigate("/success")
        }
      } catch (e: any) {
        if (e?.response?.data?.error === "invalid_request") {
          navigate("/error")
        }
        resolve(e.response.data)
      } finally {
        dispatch(changeLoading(false))
      }
    })

  return api
}

type ClientDetailRequest = {
  code: string
}
type LoginMethods = "email" | "phone"

export type PasswordPatternRequirement = {
  minLength: number
  upperCase: boolean
  lowerCase: boolean
  number: boolean
  specialCharacter: boolean
}

export type ClientDetailResponse = {
  name: string
  nameZh: string
  loginMethods: LoginMethods[]
  countryCodes: string[]
  omitPassword: boolean
  passwordPatternRequirement: PasswordPatternRequirement
}

export const useClientDetailRequest = () => {
  const dispatch = useAppDispatch()
  const code = useAppSelector((state: RootState) => state.app.code)
  const api = (_code?: string) =>
    new Promise<ClientDetailResponse>(async (resolve, reject) => {
      dispatch(changeLoading(true))
      try {
        const res = await $axios.post<
          ClientDetailResponse,
          AxiosResponse<ClientDetailResponse>,
          ClientDetailRequest
        >("/oauth/clientDetail", {
          code: _code || code,
        })
        console.log(res)
        resolve(res.data)
      } catch (e: any) {
        resolve(e.response.data)
      } finally {
        dispatch(changeLoading(false))
      }
    })

  return api
}
